import PropTypes from 'prop-types'
import {
  List,
  Avatar,
  ListItem,
  Typography,
  ListItemText,
  ListItemAvatar,
  Badge,
  Box,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import profilePic from '../../../../assets/defaultAvatar.png'
import BadgeStatus from 'src/components/BadgeStatus'
import { formatDistanceToNowStrict } from 'date-fns'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import Label from 'src/components/Label'
import { DOMAIN, REST_API_END_POINT } from 'src/constants/DefaultValues'
import { createChatSocket } from 'src/Helpers/createSocket'
import { WA } from '../whatsappTheme'
import axios from 'axios'
import { getLastHelpDeskOnlineStatus } from '../helpDeskSession'
ChatHomeListSignWise.propTypes = {
  teamMembers: PropTypes.array,
  onSelectContact: PropTypes.func,
}

// Styled Badge for Online Status
const OnlineBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-dot': {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#44b700',
    border: `2px solid ${theme.palette.background.paper}`,
  },
}))
const AvatarWrapperStyle = styled('div')({
  position: 'relative',
  width: 32, // Adjust size for group avatar
  height: 32,
  '& .MuiAvatar-img': { borderRadius: '50%' },
  '& .MuiAvatar-root': { width: '100%', height: '100%' },
})

export default function ChatHomeListSignWise({
  openSidebar,
  setHistoryMessage,
  teamMembers = [],
  onSelectContact,
  setCompose,
  openCompose,
  chatOpenTime,
  setChatOpenTime,
  selectedChatLogId,
  setSelectedChatLogId,
  selectedContact,
  compact = false,
}) {
  console.log('teamMembersdgf', teamMembers)
  const user = JSON.parse(localStorage.getItem('user'))
  const [currentTime, setCurrentTime] = useState(new Date())
  const [typingUsersMap, setTypingUsersMap] = useState({})
  const [helpDeskOnline, setHelpDeskOnline] = useState(false)
  console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhhhh', typingUsersMap)
  const socketRef = useRef(null)
  // typingUsersMap = { [conversationId]: "John Doe", ... }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (!compact) return undefined

    const cached = getLastHelpDeskOnlineStatus()
    if (cached != null) {
      setHelpDeskOnline(cached)
    }

    const syncOnlineStatus = async () => {
      if (!user?.user_id) return
      try {
        const response = await axios.post(`${REST_API_END_POINT}teams/get-user-active`, {
          userId: user.user_id,
        })
        if (response.data.status === 1) {
          const fromApi = response.data.data?.online === 1
          const latest = getLastHelpDeskOnlineStatus()
          setHelpDeskOnline(latest != null ? latest : fromApi)
        }
      } catch (error) {
        console.log('Error syncing help desk online status', error)
      }
    }
    syncOnlineStatus()

    const onOnlineStatus = (event) => {
      setHelpDeskOnline(event.detail?.online === true)
    }
    window.addEventListener('signwise-helpdesk-online', onOnlineStatus)
    return () => window.removeEventListener('signwise-helpdesk-online', onOnlineStatus)
  }, [compact])
  useEffect(() => {
    socketRef.current = createChatSocket()

    const handleTyping = (data) => {
      if (data?.domain !== DOMAIN) return

      const currentUserId = user?.user_id
      const senderId = data.senderId
      const conversationId = data.conversationId // e.g. 'user_534' or 'chat_8'

      // Don't process if the current user is the sender
      if (senderId === currentUserId) return

      const isGroup = conversationId.startsWith('chat_')
      const isRecipient = isGroup
        ? data.participants?.some((p) => p.user_id === currentUserId)
        : conversationId === `user_${currentUserId}` ||
          conversationId.includes(currentUserId)

      if (!isRecipient) return

      // Correctly use the conversationId as the key
      setTypingUsersMap((prev) => ({
        ...prev,
        [conversationId]:
          data.user?.full_name || data.user?.person_name || 'Someone',
      }))

      setTimeout(() => {
        setTypingUsersMap((prev) => {
          const updated = { ...prev }
          delete updated[conversationId]
          return updated
        })
      }, 3000)
    }

    socketRef.current.on('typing', handleTyping)

    return () => {
      socketRef.current?.off('typing', handleTyping)
    }
  }, [user?.user_id])

  return (
    <List disablePadding sx={compact ? { overflowX: 'hidden', px: 1 } : undefined}>
      {compact && teamMembers.length === 0 && (
        <Box sx={{ px: 2, py: 4, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: WA.meta }}>
            No conversations yet. Users will appear here after they send a message.
          </Typography>
        </Box>
      )}
      {teamMembers.map((conversation) => {
        console.log('conversation2222222222222', conversation)
        const isGroup = conversation.conversation_type === 'group'
        const otherParticipants = conversation.participants || [] // Assuming 'participants' contains members for the group
        const displayNames = otherParticipants
          .reduce((names, participant) => [...names, participant.full_name], [])
          .join(', ')
        const conversationKey = isGroup
          ? String(conversation.id)
          : `user_${conversation.id}`
        const isTyping = Boolean(typingUsersMap[conversationKey])
        const typingUser = typingUsersMap[conversationKey]
        const lastPreview = String(conversation?.last_message || '')
          .replace(/<\/p><p>/g, ' ')
          .replace(/<p>/g, '')
          .replace(/<\/p>/g, '')
          .replace(/<[^>]*>/g, '')
          .trim()
        const lastIsEnd =
          conversation?.last_message_type === 'end' || lastPreview === 'Chat ended'
        const waitingToStart =
          compact &&
          !isGroup &&
          Boolean(conversation?.last_message) &&
          !conversation?.chat_started
        const showEnded =
          compact &&
          lastIsEnd &&
          (isGroup || !(conversation?.unread_messages > 0))
        const showStartChat = waitingToStart && !showEnded
        const listPreview = showEnded
          ? 'Chat ended'
          : lastIsEnd && conversation?.unread_messages > 0
          ? 'New message'
          : lastPreview || (compact ? 'No messages yet' : 'Tap to chat...')
        // console.log('displayNames1', displayNames)

        // return(
        //   <ListItem
        //     key={conversation.id}
        //     button
        //     onClick={() => {onSelectContact(conversation);setCompose(false)}}
        //     sx={{
        //       py: 1.5,
        //       px: 3,
        //       borderRadius: '10px', // ✅ Smooth rounded corners
        //       transition: '0.3s',
        //       '&:hover': { bgcolor: '#0b2329' } // ✅ Correct hover effect (matches first image)
        //     }}
        //   >
        //     <ListItemAvatar>
        //       <OnlineBadge
        //         overlap="circular"
        //         variant={!conversation.active==='N' ? 'dot' : 'standard'}
        //       >
        //         <Avatar alt={conversation.full_name} src={conversation.profile_pic || profilePic} />
        //       </OnlineBadge>
        //     </ListItemAvatar>
        //     {openSidebar && (
        //     <ListItemText
        //     primary={conversation.group_name || conversation.full_name}
        //       secondary={conversation.lastMessage || 'Tap to chat...'}
        //       primaryTypographyProps={{ noWrap: true, variant: 'subtitle2', color: '#fff' }}
        //       secondaryTypographyProps={{ color: 'gray' }}
        //     />
        //     )}
        //     <Typography variant="caption" color="gray">
        //       {conversation.lastActive || '2h'}
        //     </Typography>
        //   </ListItem>
        // )
        return (
          <ListItem
            key={
              isGroup
                ? `group-${conversation.conversation_id}`
                : `user-${conversation.user_id || conversation.id}`
            }
            button
            onClick={() => {
              // setMobileChat(false)
              onSelectContact({ ...conversation, openedAt: Date.now() })
              setCompose(false)
              setHistoryMessage([])
              if (!compact) {
                let currentUnixTime = moment().unix()
                setChatOpenTime(currentUnixTime)
              } else {
                setChatOpenTime(null)
              }
              setSelectedChatLogId(null)
            }}
            sx={{
              py: compact ? 1.15 : 1.1,
              px: compact ? 1.25 : 2,
              mx: 0,
              my: compact ? 0.5 : 0,
              width: compact ? '100%' : undefined,
              boxSizing: 'border-box',
              minWidth: 0,
              overflow: 'hidden',
              borderRadius: compact ? '14px' : 0,
              transition: 'background 0.15s',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              borderBottom: compact ? 'none' : '1px solid #f0f2f5',
              bgcolor:
                selectedContact &&
                ((conversation.conversation_type === 'group' &&
                  Number(selectedContact.conversation_id) ===
                    Number(conversation.conversation_id)) ||
                  (conversation.conversation_type !== 'group' &&
                    selectedContact.user_id &&
                    selectedContact.user_id === conversation.user_id))
                  ? WA.listActive
                  : 'transparent',
              '&:hover': {
                bgcolor: WA.listHover,
                transform: 'none',
              },
            }}
          >
            <ListItemAvatar
              sx={{
                minWidth: openSidebar ? 'auto' : 'auto',
                marginRight: openSidebar ? 2 : 0,
                marginBottom: openSidebar ? 0 : 1,
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: openSidebar ? 48 : 44,
                  height: openSidebar ? 48 : 44,
                  '& .avatarWrapper': {
                    position: 'absolute',
                    width: openSidebar ? 32 : 30,
                    height: openSidebar ? 32 : 30,
                    '&:nth-child(1)': {
                      left: 0,
                      zIndex: 9,
                      bottom: 2,
                      '& .MuiAvatar-root': { border: 'solid 2px #000' },
                    },
                    '&:nth-child(2)': { top: 2, right: 0 },
                  },
                }}
              >
                {isGroup && (
                  <>
                    {otherParticipants.slice(0, 1).map((participant) => (
                      <AvatarWrapperStyle
                        className="avatarWrapper"
                        key={participant.user_id || participant.id}
                      >
                        <Avatar
                          alt={participant?.full_name}
                          src={participant?.profile_pic || profilePic}
                          sx={{
                            width: openSidebar ? 32 : 30,
                            height: openSidebar ? 32 : 30,
                          }}
                        />
                      </AvatarWrapperStyle>
                    ))}
                    {otherParticipants.length > 1 && (
                      <AvatarWrapperStyle className="avatarWrapper">
                        <Box
                          sx={{
                            width: openSidebar ? 32 : 30,
                            height: openSidebar ? 32 : 30,
                            borderRadius: '50%',
                            bgcolor: WA.header,
                            color: '#fff',
                            fontSize: 11,
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: compact ? '2px solid #fff' : 'solid 2px #000',
                          }}
                        >
                          +{otherParticipants.length - 1}
                        </Box>
                      </AvatarWrapperStyle>
                    )}
                  </>
                )}
                {!isGroup && (
                  <Avatar
                    alt={conversation?.full_name}
                    src={conversation?.profile_pic || profilePic}
                    sx={{
                      width: compact ? 42 : openSidebar ? 48 : 44,
                      height: compact ? 42 : openSidebar ? 48 : 44,
                    }}
                  />
                )}
              </Box>
            </ListItemAvatar>

            {openSidebar ? (
              <>
                <ListItemText
                  sx={{ minWidth: 0, overflow: 'hidden' }}
                  primary={
                    isGroup ? (
                      conversation.group_name
                    ) : (
                      <>
                        {conversation.full_name}
                        {conversation.user_type === 'client' && (
                          <span style={{ color: 'primary.main' }}>
                            {' '}
                            (Client)
                          </span>
                        )}
                      </>
                    )
                  }
                  primaryTypographyProps={{
                    noWrap: true,
                    variant: 'subtitle2',
                    color: '#0F172A',
                    style: { fontWeight: compact ? 700 : 500 },
                  }}
                  secondary={
                    isTyping ? (
                      <Typography
                        component="span"
                        style={{ fontStyle: 'italic', color: '#ccc' }}
                      >
                        {isGroup ? `${typingUser} is typing...` : 'typing...'}
                      </Typography>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: (() => {
                            if (!isGroup) return listPreview
                            const groupText = lastPreview
                            if (!groupText) return compact ? 'No messages yet' : 'Tap to chat...'
                            const isEvent =
                              conversation?.last_message_type === 'system' ||
                              conversation?.last_message_type === 'end' ||
                              /joined the chat$/i.test(groupText) ||
                              /left the chat$/i.test(groupText) ||
                              groupText === 'Chat ended'
                            if (isEvent) return groupText
                            const who =
                              conversation?.last_message_sender_id === user.user_id
                                ? 'You'
                                : conversation?.last_message_sender
                            return `${who}: ${groupText}`
                          })(),
                        }}
                      />
                    )
                  }
                  secondaryTypographyProps={{
                    color: 'gray',
                    noWrap: true,
                  }}
                />
                <Box
                  sx={{
                    ml: 1,
                    height: 44,
                    display: 'flex',
                    alignItems: 'flex-end',
                    flexDirection: 'column',
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      mb: 0.75,
                      fontSize: 11,
                      lineHeight: '18px',
                      whiteSpace: 'nowrap',
                      px: showEnded || showStartChat ? 1 : 0,
                      py: showEnded || showStartChat ? 0.25 : 0,
                      borderRadius: 8,
                      bgcolor: showEnded
                        ? '#EEF1F4'
                        : showStartChat
                        ? helpDeskOnline
                          ? 'rgba(2, 125, 194, 0.12)'
                          : '#EEF1F4'
                        : 'transparent',
                      color:
                        showStartChat && helpDeskOnline
                          ? WA.unread
                          : conversation?.unread_messages > 0
                          ? WA.unread
                          : WA.meta,
                      fontWeight: showStartChat || showEnded ? 700 : 400,
                    }}
                  >
                    {showEnded
                      ? 'Ended'
                      : showStartChat
                      ? 'Start chat'
                      : conversation?.last_message_time
                      ? (() => {
                          const messageTime = new Date(
                            moment.unix(conversation?.last_message_time),
                          )
                          const distance = formatDistanceToNowStrict(
                            messageTime,
                            { addSuffix: false, baseDate: currentTime },
                          )
                          if (distance.includes('second')) {
                            return 'just now'
                          }
                          return distance
                        })()
                      : ''}
                  </Box>
                  {conversation?.unread_messages > 0 && (
                    <Box
                      sx={{
                        minWidth: 20,
                        height: 20,
                        px: 0.5,
                        borderRadius: 10,
                        bgcolor: WA.unread,
                        color: '#fff',
                        fontSize: 11,
                        fontWeight: 700,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 0.25,
                      }}
                    >
                      {conversation.unread_messages > 99
                        ? '99+'
                        : conversation.unread_messages}
                    </Box>
                  )}
                </Box>
              </>
            ) : (
              // Collapsed state - show only avatar and truncated name
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  position: 'relative',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '11px', // Slightly larger font
                    fontWeight: 600, // Bolder font weight
                    color: 'text.primary',
                    textAlign: 'center',
                    lineHeight: 1.3,
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    mt: 0.5,
                    transition: 'color 0.2s ease-in-out',
                    px: 1, // More padding for better spacing
                    width: '100%',
                    display: 'block',
                    letterSpacing: '0.02em', // Better letter spacing
                  }}
                  title={isGroup ? conversation.group_name : conversation.full_name} // Show full name on hover
                >
                  {isGroup ? conversation.group_name : conversation.full_name}
                </Typography>
                {conversation?.unread_messages > 0 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -5,
                      right: 5,
                      backgroundColor: '#ff4444',
                      color: 'white',
                      borderRadius: '50%',
                      minWidth: 16,
                      height: 16,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      animation: 'pulse 2s infinite',
                      '@keyframes pulse': {
                        '0%': {
                          transform: 'scale(1)',
                          opacity: 1,
                        },
                        '50%': {
                          transform: 'scale(1.1)',
                          opacity: 0.8,
                        },
                        '100%': {
                          transform: 'scale(1)',
                          opacity: 1,
                        },
                      },
                    }}
                  >
                    {conversation.unread_messages > 9 ? '9+' : conversation.unread_messages}
                  </Box>
                )}
              </Box>
            )}
          </ListItem>
        )
      })}
    </List>
  )
}
